import { throttle } from 'lodash';
import { checkInView } from '../utils/index';
import Bus from '../utils/event-bus';

const Events = ['scroll', 'resize', 'load'];

function find(arr, el) {
    let i, len;
    for (i = 0, len = arr.length; i < len; ++i) {
        if (arr[i].el === el) {
            return i;
        }
    }
    return -1;
}

const Lazy = {
    install(Vue, config) {
        let imgs = [];
        let components = [];
        let opt = config || {
            preload: 0
        };

        function processImg() {
            let i, len;
            for (i = 0, len = imgs.length; i < len; ++i) {
                checkAndLoadImg(imgs[i]);
            }
        }

        function processComponent() {
            let i, len;
            for (i = 0, len = components.length; i < len; ++i) {
                checkAndLoadComp(components[i]);
            }
        }

        function checkAndLoadImg(img) {
            if (!img.loading && !img.loaded && checkInView(img.el, opt.preload)) {
                loadImg(img);
            }
        }

        function checkAndLoadComp(comp) {
            if (!comp.loaded && checkInView(comp.el, opt.preload)) {
                comp.handler.call();
                comp.loaded = true;
            }
        }

        function process() {
            processImg();
            processComponent();
        }

        function updateImg(src, el) {
            let index = find(imgs, el);
            let defaultImg = el.getAttribute('src');
            let img = {
                el,
                src,
                loading: false,
                loaded: false,
                defaultImg
            };

            if (index !== -1) {
                imgs[index] = img;
            } else {
                imgs.push(img);
            }

            Vue.nextTick(function () {
                checkAndLoadImg(img);
            });
        }

        function updateComp(src, el) {
            let i = find(components, el);
            let comp = {
                el,
                id: src.id,
                loaded: false,
                handler: src.handler || function () { }
            };

            if (i !== -1) {
                // id 不同时才需要重置状态
                if (components[i].id !== src.id) {
                    components[i] = comp;
                    Vue.nextTick(function () {
                        checkAndLoadComp(comp);
                    });
                }
            } else {
                components.push(comp);
                Vue.nextTick(function () {
                    checkAndLoadComp(comp);
                });
            }
        }

        function update(src, el) {
            let t = typeof src;
            if (t === 'string') {
                updateImg(src, el);
            } else if (t === 'object') {
                updateComp(src, el);
            }
        }

        function loadImg(img) {
            if (img.loading || img.loaded) return;

            img.loading = true;
            let i = new Image();

            i.onload = function () {
                img.el.src = img.src;
                img.loading = false;
                img.loaded = true;
                img.el.setAttribute('lazy', 'loaded');
            };
            i.onerror = function () {
                img.loading = false;
                img.loaded = true;
                img.el.src = img.defaultImg;
            };
            i.src = img.src;
        }

        Vue.directive('lazy', {
            bind(el, binding) {
                let src = binding.value;
                update(src, el);
            },
            update(el, binding) {
                let src = binding.value;
                update(src, el);
            },
            componentUpdated(el, binding) {
            },
            unbind(el, binding) {
                let src = binding.value;
                if (typeof src === 'object') {
                    let index = find(components, el);
                    if (index !== -1) {
                        components.splice(index, 1);
                    }
                }
            }
        });

        let tProcess = throttle(process, 200, 100);
        function watchSelector(selector) {
            let el = window.document.querySelector(selector);
            if (!el) {
                window.setTimeout(() => {
                    watchSelector(selector);
                }, 500);
            } else {
                for (let j = 0; j < Events.length; ++j) {
                    el.addEventListener(Events[j], tProcess);
                }
            }
        }
        if (typeof window !== 'undefined') {
            if (opt.selector) {
                watchSelector(opt.selector);
            } else {
                for (let j = 0; j < Events.length; ++j) {
                    window.addEventListener(Events[j], tProcess);
                }
            }
        }

        Bus.$on('updateFloor', function () {
            tProcess();
        });

        Bus.$on('appMounted', function () {
            tProcess();
        });
        if (typeof window !== 'undefined') {
            window.triggerLazyProcess = tProcess;
        }
    }
};

export default Lazy;
